import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/authContext";

const Home = () => {
  const { currentUser } = useContext(AuthContext);
  const [nowPlaying, setNowPlaying] = useState({ song: "", artist: "" });
  const [links, setLinks] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [recentPictures, setRecentPictures] = useState([]);

useEffect(() => {
    const fetchLinks = async () => {
      try {
        const res = await axios.get("/api/links");
        setLinks(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchLinks();
  }, []);
  useEffect(() => {
    const fetchNowPlaying = async () => {
      try {
        const res = await axios.get("/api/now-playing");
        setNowPlaying(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchNowPlaying();
  }, []);

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        const res = await axios.get("/api/posts");
        setRecentPosts(res.data.slice(0, 3));
      } catch (err) {
        console.log(err);
      }
    };
    fetchRecentPosts();
  }, []);

  useEffect(() => {
    const fetchRecentPictures = async () => {
      try {
        const res = await axios.get("/api/pictures");
        setRecentPictures(res.data.slice(0, 4));
      } catch (err) {
        console.log(err);
      }
    };
    fetchRecentPictures();
  }, []);

  const getText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent;
  };

  return (
    <div className="welcome">
      <div className="sidebar">
        <div className="sidebar-box profile-box">
          <img src="/upload/R1-01022-0015.JPG" alt="Emma" />
          <h3>WELCOME TO MY BLOG</h3>
          <p>
            Hello there friend! I figured out how to build a blog with some
            help from my dad, ainsley, the internet and welll.. I guess I
            should cite AI... Ugh sorry its lame but I'm not a CS genius. I
            will be soon thanks to Youtube! I made this to be able to share
            my life updates and photos with the people I love, while removing
            myself from social media. Thanks for reading, &lt;3.
          </p>
        </div>

<div className="sidebar-box links-box">
          <h3>&gt; links</h3>
          {links.map((link) => (
            <a href={link.url} key={link.id} target="_blank" rel="noopener noreferrer">
              {link.title}
            </a>
          ))}
          {currentUser?.username === "emma20106" && (
            <a href="/edit-links" className="edit-song-link">edit links</a>
          )}
        </div>

        <div className="sidebar-box now-playing">
          <span className="badge">♫ NOW PLAYING</span>
          <div className="song">"{nowPlaying.song}"</div>
          <div className="artist">{nowPlaying.artist}</div>
          {currentUser?.username === "emma20106" && (
            <a href="/edit-song" className="edit-song-link">edit</a>
          )}
        </div>
      </div>

      <div className="main">
        <div className="posts-placeholder">
          <h1>recent posts</h1>
          {recentPosts.length === 0 ? (
            <p>No posts yet!</p>
          ) : (
            <div className="recent-posts-strip">
              {recentPosts.map((post) => (
                <a className="recent-post-row" href={`/post/${post.id}`} key={post.id}>
                  <span className="recent-post-title">{post.title}</span>
                  <span className="recent-post-snippet">
                    {getText(post.desc).slice(0, 80)}...
                  </span>
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="posts-placeholder pictures-strip-box">
          <h1>recent photos</h1>
          {recentPictures.length === 0 ? (
            <p>No photos yet!</p>
          ) : (
            <div className="recent-pictures-strip">
              {recentPictures.map((pic) => (
                <a href={`/picture/${pic.id}`} key={pic.id}>
                  <img src={`/upload/${pic.img}`} alt={pic.caption || "photo"} />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
